import React from "react";
import "./styles.scss";
import {
  Box,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  FILTER_BY_DURATION,
  FILTER_BY_END_TIME_FROM,
  FILTER_BY_END_TIME_TO,
  FILTER_BY_RATING,
  FILTER_BY_RATING_OPERATOR,
  FILTER_BY_STATUS,
} from "../../../constants/filterConst";
import FilterDialog from "../filter";
import FilterItem from "../filterItem";

function RentalFilter(props) {
  const {
    visible,
    hideFilter,
    changeSelectorValue,
    apply,
    cancel,
    filterProps,
    statuses = [],
  } = props;

  const handleChangeSelectorValue = (filter, filterBy) =>
    changeSelectorValue(filter, filterBy);

  const handleRatingOperatorChange = (event) => {
    changeSelectorValue(event.target.value, FILTER_BY_RATING_OPERATOR);
  };

  const ratingOptions = [
    { id: 1, label: "1 star", name: "20" },
    { id: 2, label: "2 stars", name: "40" },
    { id: 3, label: "3 stars", name: "60" },
    { id: 4, label: "4 stars", name: "80" },
    { id: 5, label: "5 stars", name: "100" },
  ];

  const currentRatingOperator =
    (filterProps || []).find((f) => f.filterBy === FILTER_BY_RATING_OPERATOR)
      ?.filter || "eq";

  const currentRatingValue = (filterProps || []).find(
    (f) => f.filterBy === FILTER_BY_RATING
  )?.filter;

  const endTimeFromValue =
    (filterProps || []).find((f) => f.filterBy === FILTER_BY_END_TIME_FROM)
      ?.filter || "";
  const endTimeToValue =
    (filterProps || []).find((f) => f.filterBy === FILTER_BY_END_TIME_TO)
      ?.filter || "";

  return (
    <FilterDialog
      visible={visible}
      hideDialog={hideFilter}
      apply={apply}
      cancel={cancel}
      body={
        <>
          <FilterItem
            filterBy={FILTER_BY_STATUS}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={statuses.map((item, index) => ({
              id: index,
              name: item,
            }))}
            filterProps={filterProps}
          />
          <Box display="flex" flexDirection="row" alignItems="center" ml={2}>
            <InputLabel className={"filterInputLabel"}>
              {FILTER_BY_RATING.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
                .toLowerCase()
                .replace(/_/g, " ")}
            </InputLabel>
            <Box mb={2.5} ml={1}>
              <RadioGroup
                row={true}
                value={currentRatingOperator}
                onChange={handleRatingOperatorChange}
              >
                <FormControlLabel
                  value="eq"
                  control={
                    <Radio size="small" disabled={!currentRatingValue} />
                  }
                  label="="
                  disabled={!currentRatingValue}
                />
                <FormControlLabel
                  value="gte"
                  control={
                    <Radio size="small" disabled={!currentRatingValue} />
                  }
                  label="≥"
                  disabled={!currentRatingValue}
                />
                <FormControlLabel
                  value="lte"
                  control={
                    <Radio size="small" disabled={!currentRatingValue} />
                  }
                  label="≤"
                  disabled={!currentRatingValue}
                />
              </RadioGroup>
            </Box>
            <Box width="45%">
              <FilterItem
                filterBy={FILTER_BY_RATING}
                showLabel={false}
                changeSelectorValue={handleChangeSelectorValue}
                selectorItems={ratingOptions}
                filterProps={filterProps}
              />
            </Box>
          </Box>
          <FilterItem
            filterBy={FILTER_BY_DURATION}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={[
              {
                id: 1,
                name:
                  (filterProps.filterValue || []).find(
                    (f) => f.filterBy === FILTER_BY_DURATION
                  )?.filter || "",
                type: "number",
                label: "minutes",
              },
            ]}
            filterProps={filterProps}
            customLabel="max duration"
          />
          <FilterItem
            filterBy={FILTER_BY_END_TIME_FROM}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={[
              { id: 1, name: endTimeFromValue.split("T")[0], type: "date" },
            ]}
            filterProps={filterProps}
          />
          <FilterItem
            filterBy={FILTER_BY_END_TIME_TO}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={[
              { id: 1, name: endTimeToValue.split("T")[0], type: "date" },
            ]}
            filterProps={filterProps}
          />
        </>
      }
    />
  );
}

export default RentalFilter;
